/** @jsxImportSource theme-ui */
import { jsx } from "theme-ui";
import React from "react";
import { Global, css } from "@emotion/react";
import { Flex, Box } from "@theme-ui/components";
import { useSelector } from "react-redux";
import reset from "../../styles/reset";
import HeaderV2 from "./headerV2";
import Footer from "./footer";
import menuItems from "../../data/menu.yml";
import meMenuItems from "../../data/me_menu.yml";
import idMenuItems from "../../data/id_menu.yml";
import sgMenuItems from "../../data/sg_menu.yml";
import idBahasaMenuItems from "../../data/id_bahasa_menu.yml";
import AnnouncementBanner from "../shared/AnnouncementBanner";
import "react-multi-carousel/lib/styles.css";

const globalStyle = css`
  ${reset}
`;

const Layout2 = ({
  region,
  children,
  showHeader = true,
  showFooter = true,
  showStickyFooter = true,
  isMenuRequired = true,
  menuItems: menuItemsProp,
  meMenuItems: meMenuItemsProp,
  idMenuItems: idMenuItemsProp,
  sgMenuItems: sgMenuItemsProp,
  idBahasaMenuItems: idBahasaMenuItemsProp,
  newFeatureMenuItemID,
  displayBannerLoginCTA,
  displayBannerSupportCTA,
  showHeaderCTA,
  displaySecondaryCTA,
  displayPrimaryCTA,
  isHrGarden,
  isHomePage,
  isLoginPage,
  showAnnouncementBanner = true,
  newFeatureMenuItem,
  menuPromoData,
}) => {
  const regionMenuItemsMap = {
    IN: menuItemsProp ?? menuItems,
    ME: meMenuItemsProp ?? meMenuItems,
    ID: idMenuItemsProp ?? idMenuItems,
    "ID-id": idBahasaMenuItems ?? idBahasaMenuItemsProp,
    SG: sgMenuItemsProp ?? sgMenuItems,
    MY: null,
  };
  region = region || useSelector((state) => state.app.region);

  const bannerContent = newFeatureMenuItem?.nodes?.filter(
    (item) => item.region === region,
  )[0]?.newFeatureMenuItem;

  return (
    <Box sx={{ fontFamily: "body", m: 0 }}>
      <Global styles={globalStyle} />
      <Flex
        sx={{
          flexDirection: "column",
          minHeight: "100vh",
        }}
        as="div"
      >
        {showAnnouncementBanner && (
          <AnnouncementBanner
            newFeatureMenuItem={
              bannerContent?.url !== "" &&
              bannerContent?.label !== "" &&
              bannerContent
            }
            newFeatureMenuItemID={newFeatureMenuItemID}
            displayBannerLoginCTA={displayBannerLoginCTA}
            displayBannerSupportCTA={displayBannerSupportCTA}
            region={region}
          />
        )}
        {showHeader && (
          <HeaderV2
            region={region}
            menuHeaderItems={regionMenuItemsMap}
            showHeaderCTA={showHeaderCTA}
            displaySecondaryCTA={displaySecondaryCTA}
            displayPrimaryCTA={displayPrimaryCTA}
            isHrGarden={isHrGarden}
            isMenuRequired={isMenuRequired}
            newFeatureMenuItem={newFeatureMenuItem}
            newFeatureMenuItemID={newFeatureMenuItemID}
            isHomePage={isHomePage}
            isLoginPage={isLoginPage}
            displayBannerLoginCTA={displayBannerLoginCTA}
            displayBannerSupportCTA={displayBannerSupportCTA}
            menuPromoData={menuPromoData}
          />
        )}
        <div sx={{ flex: "1 1 auto" }}>{children}</div>
        {showFooter && (
          <Footer region={region} showStickyFooter={showStickyFooter} />
        )}
      </Flex>
    </Box>
  );
};

export default Layout2;
